import { useMemo, useState } from "react";
import { useSelector, useDispatch } from "react-redux";

import { useHostSelector } from "@hooks";

import { customUseEffect } from "@common";

import { setCompetencySearchTerm } from "@features";

const useCompetencyFrameworkController = ({
  showAdd,
  setShowAdd,
  showViewDetails,
  setShowViewDetails,
  viewMode,
  setViewMode,
  displayFeatureRows,
  visibleStatusItems,
  statusItems,
  rowsByStatus,
  effectiveVisibleStatuses,
  visibleStatuses,
  setVisibleStatuses,
  handleUpload,
  handleDownloadTemplate,
  renderFeatureView,
  showArchive,
  handleArchive,
  handleUnArchive
}) => {
  const [columnAnchorEl, setColumnAnchorEl] = useState(null);
  const competencyFramework = useSelector((state) => state.competencyFramework);
  const [searchTerm, setSearchTerm] = useState(competencyFramework?.searchCompetencyData);

  // Sync when Redux state changes externally
  customUseEffect(() => {
    setSearchTerm(competencyFramework?.searchCompetencyData || "");
  }, [competencyFramework?.searchCompetencyData]);

  const permissionsData = useHostSelector((state) => state?.permissions?.data);

  const dispatch = useDispatch();

  const permissions = useMemo(
    () => ({
      upload: permissionsData?.has(
        "Project360.ProductFeatures.createProductFeaturesUpload",
      ),
      download: permissionsData?.has(
        "Project360.ProductFeatures.getProductFeaturesTemplate",
      ),
    }),
    [permissionsData],
  );

  return {
    heading: showArchive ? "Archived Frameworks" : "Competency Frameworks",
    compact: showViewDetails,
    newBtn: {
      showAdd,
      setShowAdd,
    },
    search: {
      searchTerm,
      handleSearch: (value) => {
        setSearchTerm(value);
        dispatch(setCompetencySearchTerm(value));
      },
      handleSearchClear: () => {
        setSearchTerm("");
        dispatch(setCompetencySearchTerm(""));
      },
      placeholder: "Search Competency...",
    },
    view: {
      viewMode,
      setViewMode,
      data: displayFeatureRows,
    },
    column: {
      title: "Choose Competency Statuses",
      columnAnchorEl,
      setColumnAnchorEl,
      visibleStatusItems,
      statusItems,
      heading: "Show Competency Statuses",
      rowsByStatus,
      effectiveVisibleStatuses,
      visibleStatuses,
      setVisibleStatuses,
    },
    uploadAndDownload: {
      canUpload: permissions?.upload,
      canDownload: permissions?.download,
      handleUpload: handleUpload,
      handleDownloadTemplate: handleDownloadTemplate,
    },
    archive: {
      showArchive,
      archiveTooltip: "View All Frameworks",
      unarchiveTooltip: "Archived Frameworks",
      handleArchive: handleArchive,
      handleUnArchive: handleUnArchive
    },
    kanbanView: {
      renderFeatureView,
    },
  };
};
export default useCompetencyFrameworkController;
